import { render, staticRenderFns } from "./SingleSetPage.vue?vue&type=template&id=82486cbe&scoped=true"
import script from "./SingleSetPage.vue?vue&type=script&lang=js"
export * from "./SingleSetPage.vue?vue&type=script&lang=js"
import style0 from "./SingleSetPage.vue?vue&type=style&index=0&id=82486cbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82486cbe",
  null
  
)

export default component.exports